/**
 * 車両カード（`VehicleInfoView`）のうち「1 日の 1 回転」に紐づく表示。
 *
 * `/map`・カード型配車は 1 日を描くので、どれも読める数字になっている。長距離配車
 * （`/long-haul`）のレーンは期間全体（最大 10 日）にまたがるため、1 回転ぶんの値を
 * 出すと何の数字なのかが読めなくなる（積載量も運賃も勤務時間も日ごとに変わる）。
 *
 * - `capacity`   … 積載量の数値（`0 / 2,800kg`）と容量バー
 * - `grossProfit`… 粗利（`粗利 ¥0`）
 * - `driverShift`… 勤務時間（`03:00–23:00`）
 * - `rotation`   … 回転バッジ（`2回転目`）と回転の追加・削除ボタン
 * - `deliveryTag`… 納品タグ（`納品3`）。その行が回る納品先の地点数
 * - `pickupTag`  … 積込タグ（`積込2`）。その行が積みに行く地点数
 *
 * 納品 / 積込 は表示項目で ON にしたときだけ出るが、数えるのは渡された行の cards だけ。
 * 長距離はレーンを代表行 1 本に畳んで渡すので、レーンの他の運行の地点が数に入らない。
 */
export type DailyVehicleMetric =
  | 'capacity' | 'grossProfit' | 'driverShift' | 'rotation' | 'deliveryTag' | 'pickupTag';

/**
 * 何も隠さない状態。
 *
 * 既定を「すべて出す」にしているので、prop を渡さない既存 2 画面は現状どおりになる。
 * モジュール定数にするのは、既定値にリテラルを置くと描画のたびに新しい Set になり、
 * 車両リストが行へ素通しする prop 群（`rowProps`）の memo が毎回外れるため。
 */
export const NO_HIDDEN_DAILY_METRICS: ReadonlySet<DailyVehicleMetric> = new Set();
